import React, { useState } from "react";
import "../styles/about.css";

const AboutClients = ({
    onNavigate,
    hasUnreadFeedback,
    highlightedFeedbacks = new Set(),
    feedbacksEnabled = true,
    hasClientAccess = false,
    showLogout = false,
}) => {
    const APP_VERSION = "1.0.11";
    const WEBSITE_URL = "https://workrestart.in.ua";
    const [expandedSections, setExpandedSections] = useState({});

    const canUseFeedbacks = feedbacksEnabled && hasClientAccess;

    const toggleSection = (sectionId) => {
        setExpandedSections((prev) => ({
            ...prev,
            [sectionId]: !prev[sectionId],
        }));
    };

    const handleFeedback = () => {
        if (!canUseFeedbacks) return;
        if (onNavigate) {
            onNavigate("feedbacks");
        }
    };

    const sections = [
        {
            id: "about",
            title: "📱 Про програму",
            description:
                "WorkRestart - це комплексна платформа для управління комунікацією ОСББ та пристроями. Ми допомагаємо забудовам, мешканцям та операторам ефективно взаємодіяти та керувати повсякденними завданнями.",
        },
        {
            id: "version",
            title: "📦 Версія програми",
            version: APP_VERSION,
        },
        {
            id: "privacy",
            title: "🔐 Політика конфіденційності",
            description:
                "Ми збираємо лише необхідні дані для надання послуг: ім'я, email та дані, пов'язані з роботою сервісу. Ми не передаємо дані третім сторонам без вашої згоди або законних підстав.",
        },
        {
            id: "terms",
            title: "⚖️ Умови використання",
            description:
                "Використовуючи додаток, ви погоджуєтеся з обробкою ваших даних для надання послуг. Акаунт може бути заблоковано при порушенні правил. Для видалення акаунта використовуйте відповідну функцію в профілі.",
        },
        {
            id: "support",
            title: "📞 Служба підтримки",
            description:
                "Маєте запитання чи потребуєте допомоги? Напишіть нам або залишіть відгук прямо в додатку.",
            hasButton: true,
        },
    ];

    return (
        <div className="about-container">
            {/* Голова картока з версією та вебсайтом */}
            <div className="about-info-card">
                <div className="app-title">🚀 WorkRestart</div>
                <div className="app-subtitle">Управління часом та комунікацією</div>
                <div className="info-row">
                    <span className="info-label">Версія:</span>
                    <span className="version-badge">v{APP_VERSION}</span>
                </div>
                <div className="info-row info-row--site">
                    <span className="info-label">Сайт</span>
                    <a href={WEBSITE_URL} target="_blank" rel="noreferrer" className="website-link">
                        {WEBSITE_URL.replace(/^https?:\/\//, "")}
                    </a>
                </div>
            </div>

            {/* Список секцій */}
            <div className="about-sections-list">
                {sections.map((section) => (
                    <div key={section.id} className="about-item">
                        <div
                            className="about-item-header"
                            onClick={() => toggleSection(section.id)}
                        >
                            <span className="about-item-title">
                                {section.title}
                                {section.id === "support" && (hasUnreadFeedback || highlightedFeedbacks.size > 0) && (
                                    <span style={{ color: "#dc3545", marginLeft: "8px" }}>●</span>
                                )}
                            </span>
                            <span className="expand-icon">
                                {expandedSections[section.id] ? "▲" : "▼"}
                            </span>
                        </div>
                        {expandedSections[section.id] && (
                            <div className="about-item-content">
                                {section.description && <p>{section.description}</p>}
                                {section.version && (
                                    <div className="version-detail">v{section.version}</div>
                                )}
                                {section.hasButton && canUseFeedbacks && (
                                    <button className="support-feedback-btn" onClick={handleFeedback}>
                                        {(hasUnreadFeedback || highlightedFeedbacks.size > 0) && <span style={{ color: "#dc3545", marginRight: "4px" }}>●</span>}
                                        ✍️ Залишити відгук
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {showLogout ? (
                <div className="profile-logout-card" style={{ marginTop: 14 }}>
                    <strong>Сесія</strong>
                    <p>Вихід із акаунта. Після виходу потрібно знову увійти.</p>
                    <button
                        type="button"
                        className="profile-logout-btn"
                        onClick={() => onNavigate?.("logout")}
                    >
                        Вийти з акаунта
                    </button>
                </div>
            ) : null}

            {/* Футер */}
            <div className="about-footer">
                <p>© 2025 WorkRestart. Всі права захищені.</p>
            </div>
        </div>
    );
};

export default AboutClients;
